import * as React from 'react'
import {
    useReactTable,
    getCoreRowModel,
    ColumnDef,
    SortingState,
    getSortedRowModel,
} from '@tanstack/react-table'

import { Table } from '../Table/Table'
import { Dispatch, SetStateAction } from 'react'
import { numberWithCommas } from '../../../utils/numberWithCommas'
import { useTableSorting } from '@/hooks'

type UsageAndCostTableProps = {
    data: Array<Record<string, unknown>>
    columns: ColumnDef<unknown>[]
    sorting: SortingState
    setSorting: Dispatch<SetStateAction<SortingState>>
    summaryCells: React.ReactNode[]
}

export const UsageAndCostTable: React.FC<UsageAndCostTableProps> = ({
    data,
    columns,
    sorting,
    setSorting,
    summaryCells,
}) => {
    const tableWrapperClass =
        'overflow-auto h-full absolute w-full h-full inset-0'

    const defaultColumn = {
        cell: ({ getValue }) => {
            const value = getValue()
            if (typeof value === 'number') {
                return numberWithCommas(value, 2)
            }
            return value
        },
    } as ColumnDef<unknown>

    const table = useReactTable({
        data,
        columns,
        defaultColumn,
        getCoreRowModel: getCoreRowModel(),
        state: {
            sorting,
        },
        getSortedRowModel: getSortedRowModel(),
    })

    const { onTableColumnHeaderClick, getTableColumnSorting } = useTableSorting(
        table,
        setSorting
    )

    return (
        <div className="relative h-full">
            <div className={tableWrapperClass}>
                <Table
                    summary={{ cells: summaryCells }}
                    table={table}
                    onTableColumnHeaderClick={onTableColumnHeaderClick}
                    getColumnSorting={getTableColumnSorting}
                />
            </div>
        </div>
    )
}
